import _ from 'lodash';

const applyDecimalRules = (value) => {
  const splitValue = value.toString().split('.');

  if (splitValue[1] > 0) {
    if (splitValue[1].length === 1 && splitValue[0].length === 1) {
      return value.toFixed(2).toString();
    }

    return value.toString();
  }

  let decimalValue = Math.floor(value);

  if (splitValue[0].length === 1) {
    decimalValue = (Math.floor(value * 100) / 100).toFixed(2);
  } else if (splitValue[0].length === 2) {
    decimalValue = (Math.floor(value * 10) / 10).toFixed(1);
  }

  return decimalValue.toString();
};

const getMaxNumerator = (f) => {
  var f2 = null;
  var ixe = f.toString().indexOf('E');
  if (ixe == -1) ixe = f.toString().indexOf('e');
  if (ixe == -1) f2 = f.toString();
  else f2 = f.toString().substring(0, ixe);

  var digits = null;
  var ix = f2.toString().indexOf('.');
  if (ix==-1) digits = f2;
  else if (ix===0) digits = f2.substring(1, f2.length);
  else if (ix < f2.length) digits = f2.substring(0, ix) + f2.substring(ix + 1, f2.length);

  var L = digits;

  var numDigits = L.toString().length;
  var L2 = f;
  var numIntDigits = L2.toString().length;
  if (L2 === 0) numIntDigits = 0;
  var numDigitsPastDecimal = numDigits - numIntDigits;

  var i;
  for (i=numDigitsPastDecimal; i>0 && L%2===0; i--) L/=2;
  for (i=numDigitsPastDecimal; i>0 && L%5===0; i--) L/=5;

  return L;
};

// Approximate decimal number `d` into the returned fraction `frac`,
// so that |frac - d| < (10^-precision / 2).
// In other words, return an approximate fraction correct up to the
// `precision`th decimal place.
const approximateFraction = (d, precision = 12) => {
  var numerators = [0, 1];
  var denominators = [1, 0];

  var maxNumerator = getMaxNumerator(d);
  var d2 = d;
  var calcD, prevCalcD = NaN;

  var acceptableError = Math.pow(10, -precision) / 2;

  for (var i = 2; i < 1000; i++)  {
    var L2 = Math.floor(d2);
    numerators[i] = L2 * numerators[i-1] + numerators[i-2];
    if (Math.abs(numerators[i]) > maxNumerator) return;

    denominators[i] = L2 * denominators[i-1] + denominators[i-2];

    calcD = numerators[i] / denominators[i];

    if (Math.abs(calcD - d) < acceptableError || calcD == prevCalcD) {
      return numerators[i].toString() + '/' + denominators[i].toString();
    }

    d2 = 1/(d2-L2);
  }
};

const formatOdds = (value, format = 'decimal') => {
  const floatValue = _.isNumber(value) ? value : parseFloat(value);
  const calcValue = parseFloat((floatValue - 1).toFixed(floatValue.toString().split('.')[1]?.length || 0)); // workaround due to js math quirks with floats

  switch (format) {
    case 'decimal':
    default:
      return applyDecimalRules(floatValue);

    case 'hongKong':
      return applyDecimalRules(calcValue);

    case 'fractional':
      return approximateFraction(calcValue) || applyDecimalRules(floatValue);

    case 'us':
      return floatValue >= 2 ? (calcValue * 100).toFixed(0) : (-100 / calcValue).toFixed(0);
  }
};

export default formatOdds;
